import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background/80 backdrop-blur-xl border-b border-white/5 shadow-2xl"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center justify-between h-16 md:h-20">
        <button
          onClick={() => scrollTo("hero")}
          className="font-['Cormorant_Garamond'] text-lg md:text-xl tracking-[0.15em] text-foreground font-light"
        >
          SKYN <span className="text-primary">x</span> SISTER DIAMONDS
        </button>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          <button onClick={() => scrollTo("event")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors">
            Event
          </button>
          <button onClick={() => scrollTo("hosts")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors">
            Hosts
          </button>
          <button onClick={() => scrollTo("retreat")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary transition-colors">
            Retreat
          </button>
          <Button
            data-testid="header-rsvp-btn"
            onClick={() => scrollTo("register")}
            className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-[0.2em] text-xs h-10 px-6"
          >
            RSVP
          </Button>
        </nav>

        {/* Mobile menu toggle */}
        <button
          data-testid="mobile-menu-btn"
          className="md:hidden text-foreground"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X strokeWidth={1} size={24} /> : <Menu strokeWidth={1} size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-background/95 backdrop-blur-xl border-t border-white/5 px-6 py-6 flex flex-col gap-4">
          <button onClick={() => scrollTo("event")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary text-left">Event</button>
          <button onClick={() => scrollTo("hosts")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary text-left">Hosts</button>
          <button onClick={() => scrollTo("retreat")} className="text-xs tracking-[0.15em] uppercase text-muted-foreground hover:text-primary text-left">Retreat</button>
          <Button
            onClick={() => scrollTo("register")}
            className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-[0.2em] text-xs h-10 w-fit px-6"
          >
            RSVP
          </Button>
        </div>
      )}
    </header>
  );
}
